import { useEffect, useState } from "react"
import { useMainContext } from "../../../core/contexts/main"
import FilterLayout from "../../layouts/FilterLayout"
import { Column, Row } from "../../../styles/TableStyle"
import { FlexCenter } from "../../../styles/CommonStyles"
import { SOCKET_URL } from "../../../core/constants/urls"
import { formatDate, formatNumber } from "../../../core/utils/common"
import Text from "../../../core/utils/Text"
import { useSwapHistoryQuery } from "../../../core/services/react-query/swap"
import { CgMenu } from "react-icons/cg"
import ModalLayout from "../../layouts/ModalLayout"
import SwapHistoryDetailsModal from "./SwapDetailsModal"

const initialModalState = { show: false, data: null }


const SwapHistoryTable = () => {
    const {
        main: { lang },
    } = useMainContext()

    const [modal, setModal] = useState(initialModalState)
    const onCloseModal = () => setModal(initialModalState)

    const initialState = {
        page: 1,
        dateFrom: null,
        search: {
            fromCurrency: "fromCurrency",
            toCurrency: "toCurrency",
        },
        query: {
            fromCurrency: "",
            toCurrency: "",
        },
    }
    const [filterQueries, setFilterQueries] = useState(initialState)

    const [allPages, setAllPages] = useState(null)
    const { data: orders, isFetching, refetch } = useSwapHistoryQuery(filterQueries)

    useEffect(() => {
        if ((orders && !allPages) || (orders && orders.meta.total !== allPages)) {
            setAllPages(orders.meta.total)
        }
        // eslint-disable-next-line
    }, [orders])

    useEffect(() => {
        refetch()
    }, [filterQueries, refetch])

    return (
        <>
            <FilterLayout
                headers={headers}
                data={orders}
                totalPages={allPages}
                state={{ filterQueries, setFilterQueries, initialState }}
                loading={isFetching}
            >
                {orders?.data?.map((item) => (
                    <Row key={item._id}>
                        {/* Currency */}
                        <Column width="25%">
                            <FlexCenter className="gap-1">
                                <span className="uppercase">{item.fromCurrency}</span>
                                <img
                                    src={SOCKET_URL + `assets/icon/${item.fromCurrency}.png`}
                                    alt={item.fromCurrency}
                                    width="25px"
                                    height="25px"
                                />
                                <span className="mx-1 text-lg">→</span>
                                <span className="uppercase">{item.toCurrency}</span>
                                <img
                                    src={SOCKET_URL + `assets/icon/${item.toCurrency}.png`}
                                    alt={item.toCurrency}
                                    width="25px"
                                    height="25px"
                                />
                            </FlexCenter>
                        </Column>
                        {/* amount */}
                        <Column width="15%" number>
                            {formatNumber(item.amount)}
                        </Column>

                        {/* toAmount */}
                        <Column width="15%" number>
                            {formatNumber(item.toAmount)}
                        </Column>

                        {/* wage */}
                        <Column width="15%" number>
                            {formatNumber(item.wage)}
                        </Column>

                        {/* status */}
                        <Column width="15%">
                            <span
                                className={`px-2 py-1 rounded text-xs ${item.status === "done"
                                    ? "bg-green-200 text-green-800"
                                    : item.status === "pending"
                                        ? "bg-yellow-200 text-yellow-800"
                                        : "bg-red-200 text-red-800"
                                    }`}
                            >
                                {item.status}
                            </span>
                        </Column>

                        {/* createdAt */}
                        <Column width="15%" number>
                            <div className="flex flex-col gap-1">
                                <span>
                                    {formatDate(item.createdAt, "date", lang === "en" ? "en-US" : "fa-IR")}
                                </span>
                                <span>
                                    {formatDate(item.createdAt, "time", lang === "en" ? "en-US" : "fa-IR")}
                                </span>
                            </div>
                        </Column>

                        <Column width="10%">
                            <CgMenu className="cursor-pointer" onClick={() => { setModal({ show: true, data: item }) }} />
                        </Column>
                    </Row>
                ))}
            </FilterLayout>
            <ModalLayout open={modal.show} onClose={onCloseModal} width={"600px"}>
                <SwapHistoryDetailsModal data={modal.data} onClose={onCloseModal} />
            </ModalLayout>
        </>
    )
}

const headers = [
    { title: "currency", width: "15%" },
    { title: "amount", width: "15%" },
    { title: "to-amount", width: "15%" },
    { title: "wage", width: "15%" },
    { title: "status", width: "15%" },
    { title: "date-time", width: "15%" },
    { title: "details", width: "10%" },
]

export default SwapHistoryTable
